"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceAssetFilterMap = exports.workspaceAssetSortMap = exports.workspaceFilterMap = exports.workspaceSortMap = exports.AssetType = void 0;
var AssetType;
(function (AssetType) {
    AssetType["Dataset"] = "dataset";
    AssetType["Pipeline"] = "pipeline";
    AssetType["Model"] = "model";
    AssetType["Metadata"] = "metadata";
    AssetType["Research"] = "research";
    AssetType["Apps"] = "apps";
})(AssetType || (exports.AssetType = AssetType = {}));
exports.workspaceSortMap = {
    workspaceId: "id",
    name: "name",
    description: "description",
    createdByUser_userId: "created_by_user_id",
    createdByUser_name: "createdByName",
    createdByUser_username: "createdByUsername",
    createdByUser_email: "createdByEmail",
    createdAt: "created_at",
    modifiedAt: "modified_at",
};
exports.workspaceFilterMap = {
    workspaceId: "w.id",
    name: "w.name",
    description: "w.description",
    createdByUser_userId: "w.created_by_user_id",
    createdByUser_name: "u.name",
    createdByUser_username: "u.username",
    createdByUser_email: "u.email",
    createdAt: "w.created_at",
    modifiedAt: "w.modified_at",
};
exports.workspaceAssetSortMap = {
    workspaceAssetId: "id",
    workspaceId: "workspace_id",
    name: "name",
    description: "description",
    assetType: "asset_type",
    resourceName: "resource_name",
    internalLinkId: "internal_link_id",
    createdByUser_userId: "created_by_user_id",
    createdByUser_name: "createdByName",
    createdByUser_username: "createdByUsername",
    createdByUser_email: "createdByEmail",
    createdAt: "created_at",
    modifiedAt: "modified_at",
};
exports.workspaceAssetFilterMap = {
    workspaceAssetId: "wa.id",
    workspaceId: "wa.workspace_id",
    name: "wa.name",
    description: "wa.description",
    assetType: "wa.asset_type",
    resourceName: "wa.resource_name",
    internalLinkId: "wa.internal_link_id",
    createdByUser_userId: "wa.created_by_user_id",
    createdByUser_name: "u.name",
    createdByUser_username: "u.username",
    createdByUser_email: "u.email",
    createdAt: "wa.created_at",
    modifiedAt: "wa.modified_at",
};
